import { z } from "zod"
import { EventEditScopeSchema } from "@mimber/schema"

export const CancelEventFormSchema = z.object({
  scope: EventEditScopeSchema,
})

export type CancelEventFormValues = z.infer<typeof CancelEventFormSchema>
